// extracted by mini-css-extract-plugin
export var externalLink = "_76-0";
export var internalLinkLabel = "_76-1";